export const getFirstUncompletedExercise = (milestones) => {
  let firstUncompletedEx;
  let order = 1;
  let firstSavedExercise;
  milestones.forEach((m) => {
    m.exercises.forEach((e) => {
      if (!e.exerciseComplete && !e.savedExercise && !firstUncompletedEx) {
        firstUncompletedEx = e;
      }
      if (e.savedExercise && !firstSavedExercise) {
        firstSavedExercise = e;
      }
      e.order = order;
    });
  });
  if (!firstUncompletedEx) {
    firstUncompletedEx = firstSavedExercise;
  }
  if (!firstUncompletedEx) {
    firstUncompletedEx = milestones[0].exercises[0];
  }

  return firstUncompletedEx;
};

export const getActiveExWithFormattedMilestones = (milestones) => {
  let activeExercise = milestones[0].exercises[0];
  let _milestones = [...milestones];
  let firstUncompletedEx = getFirstUncompletedExercise(milestones);

  activeExercise = firstUncompletedEx;

  return { milestones: _milestones, activeExercise };
};

export const getProgress = ({
  milestones,
  activeExercise,
  setMilestoneIndex,
  setProgress,
}) => {
  milestones.forEach((m) => {
    m?.exercises.forEach((e) => {
      if (e.id === activeExercise?.id) {
        setProgress((prev) => ({
          ...prev,
          total: m.exercises?.length,
          complete: m.exercises.filter((c) => c.exerciseComplete).length,
        }));
        setMilestoneIndex(m.milestoneId);
      }
    });
  });
};
